import { Box, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Coffee, File, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { H5 } from '../../components/Typography';
import FlexBox from '../../components/flexbox/FlexBox';

const ProfileStatsCard = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <Stack spacing={1.5}>
        <FlexBox
          onClick={() => navigate('/naver/callmetellme/jiwongum')}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <img
            src={'/static/icons/money.svg'}
            alt="money"
            style={{ width: '24px', height: '24px', marginRight: '8px' }}
          />
          <H5>지원금</H5>
        </FlexBox>

        <FlexBox
          onClick={() => navigate('/naver/callmetellme/community')}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Coffee size={24} color={theme.palette.primary.mainBlue} />
          <H5 sx={{ marginLeft: '8px' }}>커뮤니티</H5>
        </FlexBox>
        <FlexBox
          onClick={() => navigate('/naver/callmetellme/main-1')}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <File size={24} color={theme.palette.primary.mainBlue} />
          <H5 sx={{ marginLeft: '8px' }}>회사소개</H5>
        </FlexBox>
        <FlexBox
          onClick={() => navigate('/naver/callmetellme/mypage')}
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <User size={24} color={theme.palette.primary.mainBlue} />
          <H5 sx={{ marginLeft: '8px' }}>마이페이지</H5>
        </FlexBox>
      </Stack>
    </Box>
  );
};

export default ProfileStatsCard;
